import React, { useMemo } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core';

/* UI */
import { ModalMenuUI } from '../../Modal/ModalMenuUI';
import { Button } from '@cube3/cubicle/src/core/atoms/Button/Button';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gap: '16px 0',
      alignItems: 'center'
    },
    column: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    label: {
      paddingLeft: 8
    },
    icon: {
      marginRight: '-67px'
    }
  })
);

interface Properties {
  onCloseEvent: () => void;
  onSubmit: (e: React.SyntheticEvent) => void;
  valid: boolean;
  error?: string;
  loading: boolean;
  submitting: boolean;
  submitButtonLabel?: string;
  fields?: React.ReactNode;
  onClickPrevious?: () => void;
}

const AddProjectModalUI: React.FC<Properties> = (props) => {
  const {
    onCloseEvent,
    onSubmit,
    valid,
    error,
    loading,
    submitting,
    submitButtonLabel = 'Create',
    fields,
    onClickPrevious
  } = props;

  const classes = useStyles();

  const extraComponentProps = useMemo(() => {
    return {
      onSubmit: (e) => {
        e.preventDefault();
        onSubmit(e);
      }
    };
  }, [onSubmit]);

  return (
    <ModalMenuUI
      multiplyContentSpace={4}
      wide={true}
      loading={loading || submitting}
      classes={classes}
      component="form"
      extraComponentProps={extraComponentProps}
      title={'New Project'}
      onCloseEvent={onCloseEvent}
      footerLeftComponent={
        onClickPrevious ? (
          <Button
            background="secondary"
            buttonStyle="outline"
            label={'Previous'}
            disabled={loading || submitting}
            onClick={onClickPrevious}
          />
        ) : null
      }
      footerRightComponent={
        <>
          <Button
            background="secondary"
            buttonStyle="outline"
            label={'Cancel'}
            disabled={loading || submitting}
            onClick={onCloseEvent}
          />
          <Button
            label={submitButtonLabel}
            disabled={!valid || loading || submitting}
            buttonStyle="solid"
            background="primary"
            onClick={onSubmit}
            extraRootProps={{ type: 'submit' }}
          />
        </>
      }
    >
      <div className={classes.root}>
        <form>{fields}</form>
        {error && (
          <div style={{ marginTop: 8 }}>
            <Typography color="critical">{error}</Typography>
          </div>
        )}
      </div>
    </ModalMenuUI>
  );
};

export default AddProjectModalUI;
